import { Injectable } from '@angular/core';
import { EncryptStorage } from 'encrypt-storage';
import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class StorageService extends EncryptStorage {
    constructor() {
        super(environment.secretKey, {
            prefix: 'lokos',
            storageType: 'localStorage',
            encAlgorithm: 'AES',
            doNotEncryptValues: false
        });
    }
}
